var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgHelpLib = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "400px",
    height: "180px",
    viewBox: "0 0 400 180",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "HelpLib") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "HelpLib"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 400,
    height: 180
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(116.000000, 27.000000)",
    stroke: "#003A5D",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.5,129.612761 C84.4837572,129.620204 84.4675154,129.627652 84.4512744,129.635105 L84.4512744,129.590448 C71.2682211,123.557869 57.4915923,120.717921 43.1213882,121.070604 C28.7157712,121.424157 14.3419751,125.733955 0,134 L7.10542736e-14,25.8299618 C15.9547897,16.6099873 29.7579691,12 41.409538,12 C53.0500435,12 67.4135309,14.1252828 84.5,18.3758484 C101.586469,14.1252828 115.949956,12 127.590462,12 C139.242031,12 153.04521,16.6099873 169,25.8299618 L169,134 C154.658025,125.733955 140.284229,121.424157 125.878612,121.070604 C111.508408,120.717921 97.7317789,123.557869 84.5487256,129.590448 L84.5487256,129.635105 C84.5324846,129.627652 84.5162428,129.620204 84.5,129.612761 Z",
    id: "Combined-Shape",
    fill: "#7B97BC",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.9514247,126.943359 C68.1705912,117.747161 55.0053024,112.25171 44.4555584,110.457006 C33.8841728,108.658619 22.3989867,110.674195 10,116.503732 L10,11.4243821 C24.5412535,3.80812736 37.6196998,5.68434189e-14 49.2353389,5.68434189e-14 C60.8347549,5.68434189e-14 72.4229753,3.79749746 84,11.3924924 C95.5770272,3.79749664 107.165246,5.68434189e-14 118.764661,5.68434189e-14 C130.3803,5.68434189e-14 143.458746,3.80812736 158,11.4243821 L158,115.932513 C145.601013,110.864601 134.115827,109.229839 123.544442,111.028225 C112.994698,112.822929 99.8294088,118.128753 84.0485753,126.945695 L84.0485753,127 C84.032722,126.990753 84.0168713,126.981509 84.0010233,126.972269 C83.9844933,126.981509 83.9679604,126.990752 83.9514247,127 L83.9514247,126.943359 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.585391,11.2857143 L84.585391,126.502579",
    id: "Line"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Circle_I",
    transform: "translate(256.000000, 9.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#003A5D",
    strokeWidth: 6,
    fill: "#FFFFFF",
    cx: 42.5,
    cy: 42.5,
    r: 39.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "I",
    transform: "translate(32.000000, 15.000000)",
    fill: "#003A5D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.2,47.5961538 L4.2,23.2692308 L0,23.2692308 L0,16.9230769 L16.8,16.9230769 L16.8,23.2692308 L16.8,47.5961538 L21,47.5961538 L21,55 L0,55 L0,47.5961538 L4.2,47.5961538 Z",
    id: "Combined-Shape"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 9.975,
    cy: 6.34615385,
    rx: 6.825,
    ry: 6.34615385
  })))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHelpLib);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/HelpLib.fc77d74d54ef06046729fc4aa1771ec9.svg";